// extracted by mini-css-extract-plugin
module.exports = {"FlashSale":"DiscountLable_FlashSale__jv4p2","large":"DiscountLable_large__3d48Z","small":"DiscountLable_small__t7SXV","DiscountLabel":"DiscountLable_DiscountLabel__dILB1"};